module.exports = "/_next/static/images/3c2ff9fe4b62e16a1a482be2d704bbd7-hero-desktop.jpg.webp";